"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;

var react_1 = __importStar(require("react"));

var react_hook_form_1 = require("react-hook-form");

var components_utils_1 = require("@conte-ltd/components-utils");

function _Form(props, fwRef) {
  var children = props.children,
      mode = props.mode,
      _a = props.reValidateMode,
      reValidateMode = _a === void 0 ? 'onChange' : _a,
      resolver = props.resolver,
      context = props.context,
      defaultValues = props.defaultValues,
      shouldFocusError = props.shouldFocusError,
      delayError = props.delayError,
      shouldUseNativeValidation = props.shouldUseNativeValidation,
      shouldUnregister = props.shouldUnregister,
      criteriaMode = props.criteriaMode,
      onSubmit = props.onSubmit,
      onSubmitError = props.onSubmitError,
      other = __rest(props, ["children", "mode", "reValidateMode", "resolver", "context", "defaultValues", "shouldFocusError", "delayError", "shouldUseNativeValidation", "shouldUnregister", "criteriaMode", "onSubmit", "onSubmitError"]);

  var _b = (0, react_hook_form_1.useForm)({
    mode: mode,
    reValidateMode: reValidateMode,
    resolver: resolver,
    context: context,
    defaultValues: defaultValues,
    shouldFocusError: shouldFocusError,
    delayError: delayError,
    shouldUseNativeValidation: shouldUseNativeValidation,
    shouldUnregister: shouldUnregister,
    criteriaMode: criteriaMode
  }),
      handleSubmit = _b.handleSubmit,
      methods = __rest(_b, ["handleSubmit"]);

  return react_1.default.createElement("form", __assign({
    onSubmit: handleSubmit(onSubmit !== null && onSubmit !== void 0 ? onSubmit : function () {}, onSubmitError),
    ref: fwRef
  }, other), react_1.default.createElement(react_hook_form_1.FormProvider, __assign({
    handleSubmit: handleSubmit
  }, methods), (0, components_utils_1.useRunIfFunction)(children, methods, false)));
}

exports.Form = (0, react_1.forwardRef)(_Form);